import { Component, Output, EventEmitter, Input } from '@angular/core';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';

@Component({
  selector: 'aig-modal-rejected',
  imports: [ModalComponent],
  templateUrl: './modal-rejected.component.html',
  styleUrl: './modal-rejected.component.scss'
})
export class ModalRejectedComponent {
  @Input() existenSiniestros : boolean | null = null;
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  clickHide(): void {
    this.hideModal.emit(true);
  }
  public readonly supportEmail: string = 'backoffice.caixa@icp.es';
}
